
    import { mapState, mapMutations, mapActions } from 'vuex';
    import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
    import {
        faCheckCircle as fasCheckCircle,
        faExternalLinkAlt as fasExternalLinkAlt,
    } from '@fortawesome/pro-solid-svg-icons';

    import Filters from '@/components/Utils/Filters';

    export default {
        name: 'JobViewApplyCtaComplete',

        components: {
            FontAwesomeIcon,
        },

        mixins: [Filters],

        props: {
            buttonSize: {
                type: String,
                default: 'lg',
            },
        },

        data() {
            return {
                spinner: {
                    apply_again: false,
                },
                icons: {
                    fasCheckCircle,
                    fasExternalLinkAlt,
                },
            };
        },

        computed: {
            ...mapState({
                $_me: state => state.me.user,
                $_job: state => state.job.job,
                $_jobApplication: state => state.jobApplication,
                $_isApplyEnabled: state => state.job.is_apply_enabled,
            }),
        },

        methods: {
            ...mapMutations('jobApplication', {
                $_RESET_APPLY: 'RESET_APPLY',
                $_STORE_APPLY_TYPE_SEEKER: 'STORE_APPLY_TYPE_SEEKER',
            }),

            ...mapActions('job', {
                $_getJob: 'getJob',
            }),

            /* eslint-disable */
            applyAgain() {
                this.spinner.apply_again = true;
                this.$_getJob({
                    jobUuid: this.$_job.uuid,
                    createToken: true,
                }).then(() => {
                    this.$_RESET_APPLY();
                    if (this.$_me.id) {
                        this.$_STORE_APPLY_TYPE_SEEKER();
                    }
                    this.$emit('apply');
                }).finally(() => {
                    this.spinner.apply_again = false;
                });
            },
        },
    };
